<agr-dialog (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <div>
      <div class="spacing--margin-bottom">
        <div class="spacing--margin-top flex--row flex--wrap">
          {{ 'link-slaughter-results-description' | translate }}
        </div>
      </div>
    </div>
    <mat-expansion-panel
      *ngFor="let report of data.slaughterReports"
      [attr.data-test]="'slaughter-report__' + report.id"
      [expanded]="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="flex--columnfield-width panel-title">
            <mat-checkbox
              class="checkbox-icon-white"
              [attr.data-test]="'slaughter-report-select__' + report.id"
              (click)="$event.stopPropagation()"
              (change)="updateReportSelection($event, report.id)"
              >{{ 'slaughter-report' | translate }}
              {{ report.header.issueingDateTime | agrDate }}</mat-checkbox
            >
          </div>
        </mat-panel-title>
        <mat-panel-description>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label"> {{ 'slaughter-date' | translate }} </span>
            <span class="text--small text--bold label">
              {{ report.technicalResult.dateTime | agrDate }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label"> {{ 'start-date' | translate }} </span>
            <span class="text--small text--bold label">
              {{ report.technicalResult.group.groupStartDate | agrDate }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label">
              {{ 'number-of-chickens' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ report.technicalResult.numberOfAnimalsDelivered?.amount | agrNumber }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label">
              {{ 'departure-weight-kg' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ report.technicalResult.grossTotalWeight?.amount | agrNumber }}
            </span>
          </div>

          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label">
              {{ 'departure-item.type' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ getDepartureType(report) | translate }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label">
              {{ 'show-financial-data' | translate }}
            </span>
            <span class="text--small text--bold label">
              <mat-checkbox
                class="checkbox-icon-white"
                [attr.data-test]="'slaughter-report-show-financial__' + report.id"
                (click)="$event.stopPropagation()"
                (change)="updateShowFinancialData($event, report.id)"
                [checked]="report.header.type === messageTypeCode.AfterPayment"
              ></mat-checkbox>
            </span>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div
        *ngIf="showFinancialData[report.id] || report.header.type === messageTypeCode.AfterPayment"
        [attr.data-test]="'slaughter-report-financial-section__' + report.id"
      >
        <h3>{{ 'financial-results' | translate }}</h3>
        <mat-panel-description>
          <div class="flex--column field-width">
            <span class="text--small text--gray label">
              {{ 'slaughter-weight-kg' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ report.technicalResult.netWeightPayoutBase?.amount | agrNumber }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left field-width">
            <span class="text--small text--gray label">
              {{ 'departure-item.revenue' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ data.cycle.currency | agrCurrencySymbol }}
              {{
                report.technicalResult.netWeightPayoutBase?.amount *
                  report.financialResult.calculatedPricePerUnitVatExcluded | agrNumber
              }}
            </span>
          </div>
        </mat-panel-description>
      </div>
      <div>
        <h3>{{ 'link-to-barn' | translate }}</h3>
        <span class="text--small spacing--margin-right text--bold label">
          {{ report.technicalResult.group?.houseReferenceId }}
        </span>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'departure-item.barn' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            [attr.data-test]="'slaughter-report-barn-selector__' + report.id"
            (selectionChange)="updateBarnSelection($event, report.id)"
          >
            <mat-option *ngFor="let barn of barns" [value]="barn">
              {{ barn.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </div>
</agr-dialog>
